import {
  TIME_INTERVALS_ENUM,
  TENSES_TO_HUMAN_PHRASES_MAP,
} from '@packages/systems/dynamo/constants';
import {BindingSource} from '@packages/systems/dynamo/gateway';

import {
  OperatorId,
  getOperatorById,
  isComparisonOperator,
} from '@packages/systems/dynamo/utils/DynQueryUtils';
import {FauxBindingSource} from '@packages/systems/dynamo/utils/ParamPanelUtils';

export function isValueNeeded(
  fieldType: string,
  operator: OperatorId
): boolean {
  const opById = operator && getOperatorById(operator);

  return Boolean(
    (fieldType === 'Date' && isComparisonOperator(operator)) ||
    (fieldType !== 'Id' && opById && !opById.hasOwnProperty('value'))
  );
}

const DATE_UNIT_OPTIONS: ReadonlyArray<string> = Object.keys(
  TIME_INTERVALS_ENUM
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly days: "days"; readonly weeks: "weeks"; readonly months: "months"; readonly years: "years"; }'.
).map((key) => TIME_INTERVALS_ENUM[key]);

export function getAvailableDateUnitOptions() {
  return DATE_UNIT_OPTIONS;
}

const TENSE_OPTIONS: ReadonlyArray<{
  readonly id: string;
  readonly name: string;
}> = Object.keys(TENSES_TO_HUMAN_PHRASES_MAP).map((key) => ({
  id: key,
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly FUTURE: "in the future"; readonly PAST: "in the past"; }'.
  name: TENSES_TO_HUMAN_PHRASES_MAP[key],
}));

export function getAvailableDateTimeTenses() {
  return TENSE_OPTIONS;
}

export function isValueRequired(
  bindingSource: BindingSource | FauxBindingSource,
  operatorId: OperatorId
): boolean {
  // ID fields always need a value.
  // This isn't handled by isValueNeeded for legacy reasons.
  if (bindingSource.type === 'Id') {
    return true;
  }

  // Bool fields are rendered using Is on/Is Off operators and don't need a value
  if (bindingSource.type === 'Bool') {
    return false;
  }

  // Non-ID fields only need a value if the operator requires it
  return isValueNeeded(bindingSource.type, operatorId);
}
